export const REPORT_ONE_TIME = 'onetime'
export const REPORT_DAILY = 'daily'
export const REPORT_WEEKLY = 'weekly'
export const REPORT_MONTHLY = 'monthly'
export const REPORT_YEARLY = 'yearly'

export const REPORT_DAILY_EVERY_WEEK_DAY = 'every-week-day'